import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=59009418"
import script from "./Lightbox.vue?vue&type=script&lang=ts"
export * from "./Lightbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports